<template>
  <div>
    <spinner v-if="!imageSet"></spinner>
    <div v-else>
      <h1 class="align-center">Edit {{ imageSet.title }}</h1>
      <edit-form :save="update" :image-set="imageSet"></edit-form>
    </div>
  </div>
</template>

<script>
import CreateForm from './Form';
import imageSetApi from './../../../../api/image-set';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    }
  },
  components: {
    'edit-form': CreateForm,
  },
  data() {
    return {
      imageSet: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      imageSetApi.fetch(this.id, ['book']).then((imageSet) => {
        this.imageSet = imageSet;
      });
    },
    update(form) {
      imageSetApi.update(form, form.id).then(() => {
        toastr.success('Updated successfully');

        setTimeout(() => {
          location.href = '/profile/portfolio';
        }, 2000);
      });
    },
  },
};
</script>

<style lang="scss">
  .collection-edit {
    max-width: 800px;
    margin: 0 auto;

    .preloader {
      display: block;
      width: 50px;
      height: 50px;
      margin: 0 auto;
      border-top: 9px solid rgba(0, 0, 0, 0.2);
      border-right: 9px solid rgba(0, 0, 0, 0.2);
      border-bottom: 9px solid rgba(0, 0, 0, 0.2);
      border-left: 9px solid #6E1B56;
      border-radius: 50%;
      animation: load 1.1s infinite linear;
    }
  }

  @keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .collection-edit__item {
    padding: 30px 0;
    border-bottom: 2px solid #ccc;
  }

  .collection-edit__item-inner {
    display: table;
    width: 100%;
  }

  .collection-edit__item-drag-trigger {
    display: table-cell;
    width: 50px;
    vertical-align: middle;

    span {
      display: block;
      width: 8px;
      height: 8px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 5px;
      border-radius: 50%;
      background: #555555;

      &:last-of-type { margin-bottom: 0; }
    }
  }
  .collection-edit__item-img {
    display: table-cell;
    width: 100px;
    vertical-align: middle;

    img {
      width: 100%;
    }
  }
  .collection-edit__item-btns {
    display: table-cell;
    width: calc(100% - 180px);
    padding-left: 30px;
    vertical-align: middle;
    font-size: 0;

    input[type="file"] {
      display: none;
    }
  }
  .collection-edit__item-hidden-img {
    display: none;
  }

  .collection-edit__item-btn {
    display: inline-block;
    width: 30%;
    margin-right: 5%;
    padding: 15px 0;
    border: 3px solid;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    white-space: nowrap;
    cursor: pointer;

    &:last-of-type { margin-right: 0; }

    &._purple {
      border-color: #6f1b57;
      background-color: #6f1b57;
      color: #fff;
    }
    &._gray {
      border-color: #c5c5c5;
      background-color: #c5c5c5;
      color: #555555;
    }
    &._transparent {
      border-color: #555555;
      background-color: transparent;
      color: #555555;
    }
  }

  .collection-edit__btns {
    margin-top: 30px;
  }

  .collection-edit__btn {
    display: block;
    width: 400px;
    max-width: 100%;
    margin: 10px auto;
    padding: 10px 0;
    border-radius: 5px;
    color: #fff;
    text-align: center;

    &._save {
      background-color: #6f1b57;
    }
    &._add-image {
      background-color: #c5c5c5;
    }
  }

  .collection-edit__item-desc {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 2px solid #ccc;

    .save-btn {
      margin-top: 20px;
    }
  }

  .inline-loader {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 3px solid rgba(255,255,255,0.5);
    border-left-color: rgba(255,255,255,0.9);
    animation: loading-bar-spinner 0.6s linear;
    animation-iteration-count: infinite;
  }

  @keyframes loading-bar-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
